<template>
  <div id="app">
    <!--<router-view/>-->
    <Login :showLogin="show"></Login>
    <Header v-if="showHeader" />
    <Search v-if="showSearch" :searchText="txt"></Search>
    <!--内容-->
    <transition mode="out-in">
      <router-view meta="$route.meta.title" />
    </transition>
    <!--尾部-->
    <Footer v-if="showFooter" :isFixed="isFixed" ref="foot" />
    <div class="loading" v-if="showLoading">
      <img src="/static/img/loading.gif" alt="" />
    </div>
  </div>
</template>

<script>
import Header from "@/components/header/Header";
import Footer from "@/components/footer/Footer";
import Search from "@/components/search/Search";
import Login from "@/components/login/login";
import store from "@/vuex/store";
import { mappingqueryCorpIdByHostDomain } from "./api/companies";
import { getSwitchByUdcCode } from "./api/order";
import { bannersearchHomeBannerInfo } from "@/api/companies";
export default {
  name: "App",
  components: {
    Header,
    Footer,
    Search,
    Login,
  },
  computed: {
    show () {
      return store.state.showLogin;
    },
    showLoading () {
      return store.state.showLoading;
    },
  },
  data () {
    return {
      //排除搜索框
      excludeRoutes: [],
      txt: "",
      showHeader: true,
      showSearch: true,
      isFixed: false,
      showFooter: true,
      isFrist: true
    };
  },
  created () {
    console.log("=====App created");
    if (localStorage.getItem("loginUserInfo")) {
      let data = localStorage.getItem("loginUserInfo");
      data = JSON.parse(data);
      store.commit("SET_TOKEN", data);
    }
    setTimeout(() => {
      this.txt = this.$route.query.searchData;
    }, 500);
    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        // 对路由变化做出响应...
        if (this.$route.name == "loginAndRegister") {
          this.showHeader = false;
          this.showSearch = false;
          this.showFooter = false;
        } else if (this.$route.name == "shoppingCart") {
          this.showHeader = true;
          this.showSearch = false;
        } else if (this.$route.name == "commitOrder") {
          this.showHeader = true;
          this.showSearch = false;
        } else if (this.$route.name == "pay") {
          this.showHeader = true;
          this.showSearch = false;
        } else if (this.$route.name == "offTheStocks") {
          this.showHeader = true;
          this.showSearch = false;
        } else if (this.$route.name == "orderPay") {
          this.showHeader = true;
          this.showSearch = false;
        } else if (this.$route.name == "payOk") {
          this.showHeader = true;
          this.showSearch = false;
        } else {
          this.showHeader = true;
          this.showSearch = true;
          this.showFooter = true;
        }
        // setTimeout(() => {
        //   this.$nextTick(() => {
        //     if (
        //       this.$refs.foot.$el.offsetTop <
        //       document.body.clientHeight - this.$refs.foot.$el.clientHeight
        //     ) {
        //       this.isFixed = true;
        //     } else {
        //       this.isFixed = false;
        //     }
        //   });
        // }, 400);
      }
    );
    if (localStorage.getItem('loginUserInfo')) {
      getSwitchByUdcCode("CUSTPACK_FLAG")
        .then((res) => {
          if (res.data.code === 200) {
            let show = res.data.data ? true : false
            store.commit("CHANGE_PACK", show);
          }
        })
        .catch((err) => {
          store.commit("CHANGE_PACK", false);
        });
    } else {
      store.commit("CHANGE_PACK", false);
    }
  },
  methods: {

    initData () {
      if (this.$route.path === '/') return
      if (!this.isFrist) return
      bannersearchHomeBannerInfo().then(res => {
        if (res.data.code === 200) {
          store.dispatch('getHomeBanner', res.data.data)
          this.isFrist = false
        }
      });
    }
  },

  watch: {
    '$route': {
      immediate: true,
      deep: true,
      handler (val) {
        this.initData();
      }
    }
  }
};
</script>

<style lang="scss">
@import './styles/variables.scss';
.loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999;
  img {
    width: 20vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue